export default __webpack_public_path__ + "static/media/DSC05944.02de7a78.jpg";